import React from "react";
import { Stack } from "@mui/material";
import DataSetupCardHeader from "./DataSetupCardHeader";

const DataSetupMainCard = ({
  iconSrc,
  title,
  subtitle,
  actionIconSrc,
  actionText,
  children,
  cardSx,
  onAddClick,
}) => {
  return (
    <Stack spacing={3} sx={cardSx}>
      <DataSetupCardHeader
        iconSrc={iconSrc}
        title={title}
        subtitle={subtitle}
        actionIconSrc={actionIconSrc}
        actionText={actionText}
        onAddClick={onAddClick}
      />

      {/* Optional content below header */}
      {children}
    </Stack>
  );
};

export default DataSetupMainCard;
